
export default {
  name: 'IconButton',
  components: {
  },
  props: {
    icon: {
      type: String,
      default: null
    },
    border: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  }
}
